module.exports = __webpack_public_path__ + "static/media/nuint2.e020aedb.png";